import { ComponentClass } from 'react'
import { ResultProps } from '../../../../utils/ResultViewer/ResultViewer'
import Table from '../../../../utils/ResultViewer/Table'

type CompanyMetersProps = ResultProps & {
  location?: any
  /** When set, only meters belonging to these site IDs are editable. */
  editableSiteIds?: number[] | null
}

class CompanyMetersTable extends Table {
  //@ts-ignore
  public state: CompanyMetersProps
  constructor(props: CompanyMetersProps) {
    super(props)
    this.state = {
      title: props.title,
      actionItems: props.actionItems,
      dataUrl: props.dataUrl,
      data: {
        headers: {},
        data: [],
        search: [],
        pagination: {
          limit: 100,
          page: 1,
          total_count: 0,
        },
      },
      page: 1,
      orderBy: '',
      orderDirection: '',
      editCallback: props.editCallback,
      deleteCallback: props.deleteCallback,
      filterParams: {},
      location: props.location,
      canEdit: props.canEdit ?? true,
      canDelete: props.canDelete ?? true,
      editableSiteIds: props.editableSiteIds ?? null,
    }
  }

  isRowEditable(siteId: number | null | undefined): boolean {
    if (!this.state.canEdit) {
      return false
    }
    if (this.state.editableSiteIds == null) {
      return true
    }
    if (siteId == null || Number.isNaN(Number(siteId))) {
      return false
    }
    return this.state.editableSiteIds.map(Number).includes(Number(siteId))
  }

  renderRows() {
    if (this.state.data) {
      return this.state.data.data.map((row: any, index) => {
        return (
          <tr key={index}>
            {Object.keys(row)
              .filter((key) => key !== 'site_id')
              .map((key, colIndex) => {
                return this.renderRow(row, key, colIndex)
              })}
          </tr>
        )
      })
    }
    return <></>
  }

  renderHeader(key: string): JSX.Element {
    if (this.state.location === 'overview' && key === 'company') {
      return <th className='d-none'>{key}</th>
    }
    return super.renderHeader(key)
  }
  renderRow(row: any, key: string, colIndex: number): JSX.Element {
    if (this.state.location === 'overview' && key === 'company') {
      return <td className='d-none'>{row[key]}</td>
    } else if (key === 'logo') {
      let imageUrl = row[key] ? row[key] : '/public/media/avatars/blank.png'
      return (
        <td key={colIndex}>
          <div className='symbol symbol-45px me-5'>
            <img src={imageUrl} alt={row['name']} />
          </div>
        </td>
      )
    } else if (key === 'is_active' || key === 'status') {
      let badgeClass = 'badge-success'
      switch (row[key]) {
        case 'Active':
          badgeClass = 'badge-success'
          break
        case 'Passive':
          badgeClass = 'badge-warning'
          break
        case 'Disabled':
          badgeClass = 'badge-warning'
          break
      }
      return (
        <td key={colIndex}>
          <div className={'badge ' + badgeClass}>{row[key]}</div>
        </td>
      )
    } else if (key === 'edit_actions') {
      const canEditRow = this.isRowEditable(row.site_id)
      return (
        <td key={colIndex}>
          <div className='d-flex justify-content-end flex-shrink-0'>
            <button
              type='button'
              disabled={!canEditRow}
              title={canEditRow ? 'Edit' : 'Editing is not available for this meter'}
              onClick={() => {
                if (!canEditRow) {
                  return
                }
                this.props.editCallback(row[key], this.fetchData)
              }}
              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
            >
              <span className='fa fa-edit'></span>
            </button>
            {this.state.canDelete ? (
              <button
                type='button'
                onClick={() => this.props.deleteCallback(row[key], this.fetchData)}
                className='btn btn-icon btn-bg-light btn-active-color-danger btn-sm me-1'
              >
                <span className='fa fa-trash'></span>
              </button>
            ) : null}
          </div>
        </td>
      )
    } else {
      return super.renderRow(row, key, colIndex)
    }
  }
}

export default CompanyMetersTable as ComponentClass<CompanyMetersProps>
